var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7285 17.4442C26.5456 17.4442 30.4506 13.5392 30.4506 8.72212C30.4506 3.90503 26.5456 0 21.7285 0C16.9114 0 13.0063 3.90503 13.0063 8.72212C13.0063 13.5392 16.9114 17.4442 21.7285 17.4442Z",
    fill: "#566FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3301 37.6216C42.4253 33.5023 40.3507 29.7317 37.3554 26.7626C36.6284 26.0331 35.8406 25.3668 35.0004 24.771C31.1744 21.9011 26.5109 20.3688 21.7283 20.41C15.8803 20.3801 10.2577 22.6636 6.08662 26.7626C3.0913 29.7317 1.01671 33.5023 0.111966 37.6216C-0.0452921 38.35 -0.0367973 39.1045 0.136823 39.8291C0.310443 40.5538 0.644746 41.2302 1.11501 41.8083C1.60203 42.3987 2.21531 42.8724 2.90969 43.1945C3.60406 43.5165 4.36183 43.6786 5.12719 43.669H38.3294C39.097 43.6695 39.8549 43.4972 40.5469 43.1651C41.2389 42.8329 41.8473 42.3493 42.327 41.7501C42.7888 41.1788 43.1183 40.5123 43.2918 39.7984C43.4652 39.0846 43.4783 38.3412 43.3301 37.6216Z",
    fill: "#566FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIcon);
export default __webpack_public_path__ + "static/media/login-icon.40b97c5fb4c7094c7ef052296d590dac.svg";
export { ForwardRef as ReactComponent };